<!-- eslint-disable vue/no-mutating-props -->
<template>
  <TicketCountListbox v-model="item.amount" :item="item" :options="options" :title="$t('Update or clear tickets')" />
</template>

<script setup>
const props = defineProps(["item"]);

import { ref, watch } from "vue";

import { useCartStore } from "@/store/cart.ts";
const cartStore = useCartStore();

import { TicketCountListbox } from ".";
import { validateTicketCount } from "@/helpers/subcategories";

const options = ref([]);

const createOptions = (length) =>
  (options.value = Array.from({ length })
    .map((_, n) => createOption(n, props.item))
    .filter((option) => validateTicketCount(option.n, option.ticket)));

const createOption = (n, item) => ({
  n,
  ticket: {
    ...item.ticket,
  },
});

watch(props.item, () => {
  console.log("props.item", props.item);
  createOptions(1 + props.item?.allocation);
  cartStore.updateReservation();
});

setTimeout(() => {
  console.log(props.item);
  createOptions(1 + props.item?.allocation);
});
</script>
